import React from "react";
import { useState, useEffect, useContext } from "react";
import API from "../../services/api";
import { Link } from "react-router-dom";
import defaultImage from "../../assets/default_music.png";
import TrackContext from "../../contexts/track-context";
import Helper from "../../services/helper";
import { toast } from "react-toastify";
import { ErrorToast } from "../../pure-components/CustomToast";
import HarvestService from "../../services/harvestService";
import MediaTile from "../Catalog/media-tile";

const Playlist = (props) => {
  
  const trackContext = useContext(TrackContext);
  const [albumList, setAlbumList] = useState([]);

  useEffect(() => {
    (async () => {
      await loadAlbumList();
    })();
  }, []);

  const loadAlbumList = async() => {
      trackContext.setIsLoading(true);
      const reqObj = {
            refUrl : `/getlatestalbums/{memberToken}/70`, 
            method : 'get',
            headers : {
                "Accept" : "application/json",
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
          };
      await HarvestService.loadHarvestData(reqObj).then((resp) => {
        // console.log("Albums : ", resp);
        const tempData = resp.Albums;
        //sorting on last updated date :
        if(tempData?.length > 0)
          tempData.sort((a, b) => {
            const dateA = new Date(a.ReleaseDate);
            const dateB = new Date(b.ReleaseDate);
            return dateB.getTime() - dateA.getTime(); // Sorts in descending order
          })
        setAlbumList(tempData);
      }).catch((err) => {
        console.log("Album(s) Loading Error : ", err);
        toast(({ closeToast }) => <ErrorToast message={"Album(s) list loading Error."} />);
      }).finally(() => {
        trackContext.setIsLoading(false);
      })
    }

  return (
    <>
      {!trackContext.loading && albumList?.length===0 && (
        <div className="text-xl text-center text-red-500">
          {/* No Playlists Found */}
          An unexpected error occurred. Please refresh your browser window
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 gap-2 sm:gap-2 md:gap-2 mt-2">
        {albumList?.map((elem, index) => (
          <Link to={`/album/${elem?.ID}`} key={elem?.ID} className="m-1">
            {/* <div className="music-tile">
              <div className="image-container relative">
                {Helper.getArtworkURL(elem?.ID)?.length > 0? (
                  <img
                    src={Helper.getArtworkURL(elem?.ID) || defaultImage}
                    alt="Album img"
                    onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                    className="w-full border cursor-pointer object-cover aspect-square"
                    loading="lazy"
                  />
                ) : (
                  <img
                    src={defaultImage}
                    alt="Album img"
                    className="w-full border-b cursor-pointer music-image justify-center align-middle object-cover aspect-square"
                    loading="lazy"
                  />
                )}
                <span className="play_icon absolute" title="Play"></span>
              </div>
              <div className="p-2">
                <p className="text-sm font-bold line-clamp-1">{elem?.Name || elem?.DisplayTitle}</p>
                {elem.Detail?.length > 0 &&
                  <p className="text-xs sm:text-sm font-light text-left description line-clamp-2"
                    title={elem?.Detail}
                  >
                    {elem?.Detail || elem?.DisplayTitle || elem?.Name}
                  </p>
                }
              </div>
            </div> */}
              <MediaTile
                style={{ backgroundColor: "rgb(var(--bg))", color: "rgb(var(--text))" }}
                onmouseover="this.style.color='red'" 
                onmouseout="this.style.color='blue'"
                image={Helper.getArtworkURL(elem?.ID) || defaultImage}
                title={elem?.Name || elem?.DisplayTitle}
                code=""
                description={elem?.Detail || elem?.DisplayTitle || elem?.Name}
                id={elem.ID}
                // label={elem.LibraryName}
              />
          </Link>
        ))}
      </div>
    </>
  );
};

export default Playlist;


